import {
  APIError,
  customFetch,
  ErrorMessage,
  FetchParams,
  DEFAULT_API_URL,
  mergeTraceHeaders,
} from '../../common';

export const getPageInfo = async ({
  fetchFn,
  params,
}: {
  fetchFn: typeof fetch;
  params: UrlAnalysisV2.PathUserNavigationurlanalysisv2PostRequest & {
    callerId: string;
  } & FetchParams;
}): Promise<UrlAnalysisV2.PathUserNavigationurlanalysisv2PostResponse> => {
  const {
    callerId,
    fetchParams: { timeout, baseUrl = DEFAULT_API_URL } = {},
    traceHeaders,
    ...body
  } = params;
  const path = 'user_navigation/urlanalysis/v2';
  const url = `${baseUrl}/${path}`;
  const requestOptions = {
    body: JSON.stringify(body),
    headers: mergeTraceHeaders(
      {
        'Content-Type': 'application/json',
        'nike-api-caller-id': callerId,
      },
      traceHeaders,
    ),
    method: 'POST',
    path,
    timeout,
    vipAddress: 'user_navigation-urlanalysis-v2',
  };

  const result = await customFetch({
    fetchFn,
    options: requestOptions,
    url,
  });

  try {
    return await result.json();
  } catch (e) {
    throw new APIError(ErrorMessage.JSON_PARSE, {
      originalMessage: e.message,
      requestBody: JSON.parse(requestOptions.body),
      requestOptions,
      url,
    });
  }
};
